import { db, storage } from "../firebase";
import {
  setDoc,
  getDocs,
  collection,
  updateDoc,
  doc,
  deleteDoc,
} from "firebase/firestore";
import { ref, uploadBytes, deleteObject, listAll } from "firebase/storage";
import { buildUniqueNoteFileEntries } from "./noteFileNames";

// ADD NOTE
export const addNote = (note) => ({
  type: "ADD_NOTE",
  note,
});

export const startAddNote = (noteData = {}, files = []) => {
  // console.log("start add note", noteData, files);
  return async (dispatch) => {
    const {
      title = "",
      detail = "",
      filename = [],
      hn = "",
      createBy = "",
      updateAt = 0,
      createAt = 0,
    } = noteData;
    const note = { title, detail, filename, hn, createBy, updateAt, createAt };
    // console.log("action note", note);

    const docRef = doc(collection(db, "patients", note.hn, "note"));
    try {
      await setDoc(docRef, note);

      const uploadEntries = buildUniqueNoteFileEntries(files);
      await Promise.all(
        uploadEntries.map(({ file, fileName }) =>
          uploadBytes(
            ref(storage, `files/${note.hn}/${docRef.id}/${fileName}`),
            file,
          ),
        ),
      );

      const fileNames = uploadEntries.map((entry) => entry.fileName);
      await updateDoc(doc(db, "patients", note.hn, "note", docRef.id), {
        filename: fileNames,
      });
      dispatch(
        addNote({
          id: docRef.id,
          ...note,
          filename: fileNames,
        }),
      );
    } catch (error) {
      console.log(error);
    }
  };
};

// REMOVE NOTE
export const removeNote = ({ id } = {}) => ({
  type: "REMOVE_NOTE",
  id,
});

export const startRemoveNote = ({ hn, id }) => {
  return async (dispatch) => {
    const docRef = doc(db, "patients", hn, "note", id);
    return await deleteDoc(docRef).then(() => {
      const storageRef = ref(storage, `files/${hn}/${id}`);
      listAll(storageRef).then((res) => {
        res.items.forEach((itemRef) => {
          deleteObject(itemRef);
        });
      });

      dispatch(removeNote({ id }));
    });
  };
};

// EDIT NOTE
export const editNote = (id, updates) => ({
  type: "EDIT_NOTE",
  id,
  updates,
});

export const startEditNote = (id, updates, files) => {
  return async (dispatch) => {
    const docRef = doc(db, "patients", updates.hn, "note", id);
    const retainedFileNames = Array.isArray(updates.filename)
      ? updates.filename
      : [];
    const uploadEntries = buildUniqueNoteFileEntries(
      files || [],
      retainedFileNames,
    );
    const fileNames = [
      ...retainedFileNames,
      ...uploadEntries.map((entry) => entry.fileName),
    ];

    try {
      const storageRef = ref(storage, `files/${updates.hn}/${id}`);
      const storageFiles = await listAll(storageRef);
      await Promise.all(
        storageFiles.items
          .filter((itemRef) => !retainedFileNames.includes(itemRef.name))
          .map((itemRef) => deleteObject(itemRef)),
      );

      await Promise.all(
        uploadEntries.map(({ file, fileName }) =>
          uploadBytes(
            ref(storage, `files/${updates.hn}/${docRef.id}/${fileName}`),
            file,
          ),
        ),
      );

      await updateDoc(docRef, {
        ...updates,
        filename: fileNames,
      });
      dispatch(
        editNote(id, {
          ...updates,
          filename: fileNames,
        }),
      );
    } catch (error) {
      console.log(error);
    }
  };
};

// SET NOTE
export const setNotes = (notes) => ({
  type: "SET_NOTE",
  notes,
});
export const startSetNotes = (hn) => {
  return async (dispatch) => {
    const docRef = collection(db, "patients", hn, "note");
    return await getDocs(docRef).then((snapshot) => {
      const notes = [];
      snapshot.forEach(async (childSnapshot) => {
        notes.push({
          id: childSnapshot.id,
          ...childSnapshot.data(),
        });
      });

      dispatch(setNotes(notes));
    });
  };
};
